import { Reveal } from "@/components/motion";

const WORDS = ["STRATEGIC", "AWARD-WINNING", "LUXURY", "BOLD", "DATA-DRIVEN", "TIMELESS"];

const STATS = [
  { n: "9", label: "Core disciplines under one roof" },
  { n: "100%", label: "MSME certified & accountable" },
  { n: "∞", label: "Commitment to your legacy" },
];

export const MarqueeBand = () => (
  <section className="py-16 md:py-24 border-y border-[#E8E4D9] overflow-hidden" data-testid="marquee">
    <div className="marquee-track">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span
          key={i}
          className="font-serif italic text-6xl md:text-8xl font-light text-[#1A1713] mx-8 flex items-center gap-16"
        >
          {w}
          <span className="text-[#C5A059] not-italic">✦</span>
        </span>
      ))}
    </div>
  </section>
);

export const Stats = () => (
  <section className="py-28 md:py-40" data-testid="stats">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-3 gap-12 md:gap-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} i={i} className="border-t border-[#E8E4D9] pt-8">
            <div className="font-serif font-light text-7xl md:text-8xl text-[#C5A059] leading-none">
              {s.n}
            </div>
            <p className="text-sm text-[#78716C] mt-6 max-w-[220px] leading-relaxed">
              {s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
